import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button, Popover, Stack } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';

import './menu.scss';
import Color from '@tool/color';
import { CloseIcon20, DownFullIcon } from '@styled/icon';
import moMenu from './menu';
import moIndex, {
  toggleTip, toggleSingle, toggleMulti, onExport,
} from '../store/index';
import moUser from '@store/user';
import Single from './single';
import moSkin from '@/store/skin';

interface IProps {}
interface IState {}

const DButton = styled(Button)(() => ({
  justifyContent: 'space-between',
  width: '180px',
  height: '40px',
  marginTop: '10px',
  padding: '0 10px 0 16px',
  fontSize: '14px',
  fontWeight: 500,
  lineHeight: 1,
  borderRadius: '4px',
  border: `1px solid ${Color.blackColor(0.1)}`,
  color: Color.primary,
}));

const DStack = styled(Stack)(() => ({
  // position: 'absolute',
  // left: '660px',
  marginLeft: '20px',
  height: '100%',
  display: 'inline-flex',
  alignItems: 'flex-end',
  paddingBottom: '18px',
}));

const EButton = styled(Button)(() => ({
  height: '40px',
  width: '100px',
  padding: '0 10px',
  borderRadius: '6px',
}));

const Menu = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const location = useLocation();
  const {
    industry, compareIndustry, singleModal,
    multiIndustry, singleIndustry,
  } = moIndex;
  const [anchorEl, setAnchorEl] = useState(null);
  const industryRef = useRef(null);
  const [isCompare, setCompare] = useState(true);

  useEffect(() => {
    // console.log('location ++++++++++++ ', location);
    if (
      location.pathname.includes('industry-research') ||
      location.pathname.includes('wealfare-insight') ||
      location.pathname.includes('talent-flow')
    ) {
      setCompare(false);
    } else {
      setCompare(true);
    }

    return () => {
      setAnchorEl(null);
    };
  }, [location.pathname]);

  const onSingle = () => {
    /* *
    本处修改的代码是为了改变未付费会员修改行业的限制, 3.a
    需求链接: https://smartsalary.feishu.cn/wiki/EatIwkqj7irNhbkQraVcfP7Fn3g#KTDMdSnRUoSLIpxFWhncgvGknwh
    // if (moUser.isIndicatorExpired) toggleTip(true);
    // else {
    //   if (industryRef.current) setAnchorEl(industryRef.current);
    //   toggleSingle(!singleModal);
    // }
    */
    if (industryRef.current) setAnchorEl(industryRef.current);
    toggleSingle(!singleModal);
    // else toggleSingle(true);
  };

  const onMulti = () => {
    if (moUser.isIndicatorExpired) toggleTip(true);
    else toggleMulti(true);
  };

  const closePop = () => {
    // setAnchorEl(null);
    // toggleSingle(false);
  };

  return (
    <section className="menu_10">
      <section className="menu-item_10">
        <b>我所属行业</b>
        <DButton ref={industryRef} onClick={onSingle}>{industry.name}
          <DownFullIcon width={12} height={12} color={Color.da} />
        </DButton>
        {singleModal ? <Single /> : null}
      </section>
      {isCompare ? (
        <>
          <span className="little_10" />
          <section className="menu-item_10">
            <b>对比的行业</b>
            <DButton onClick={onMulti}>
              已选{compareIndustry.length}个行业
              <DownFullIcon width={12} height={12} color={Color.da} />
            </DButton>
          </section>
        </>
      ) : null}

      {moSkin.partner === 'smartsalary' && <DStack direction="row">
        <EButton variant="contained" color="primary" onClick={onExport}>生成白皮书</EButton>
      </DStack>}
    </section>
  );
};

export default observer(Menu);
